module.exports = __webpack_public_path__ + "img/t2.cfea2e09.png";